import { render, staticRenderFns } from "./OsobaDodatnaAktivnostDetails.vue?vue&type=template&id=72b9c7cc&scoped=true&"
import script from "./OsobaDodatnaAktivnostDetails.vue?vue&type=script&lang=js&"
export * from "./OsobaDodatnaAktivnostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9c7cc",
  null
  
)

export default component.exports